export default {
  caseinfo: '案件信息',
  intro: '此功能使用AI技术展示判案书的主要数据，请点击以阅读相关资讯。部分资料只有英文版。欢迎填写意见表格提供意见及回报错误。',
  case_disclaimer: '* 本栏的信息来自案件所有的判决书',
  pi: {
    title: '损害赔偿资讯 (PSLA)',
    background: {text:'原告人背景'},
    age_accident: {text:'意外发生时岁数'},
    age_trial:  {text:'审讯时岁数'},
    gender: {text:'性别'},
    male: '男性',
    female:'女性',
    occupation_bef:{text:'意外前职业'},
    occupation_aft_actual:{text:'意外后职业'},
    injuries: {text:'伤势摘要'},
    injury_type: {text:'伤势的严重程度'},
    disaster: '灾难',
    gross: '严重残疾',
    substantial: '重大受伤',
    serious: '严重受伤',
    nonserious: '一般受伤',
    loss: {text:'失去的生活乐趣'},
    loss_walk: '丧失步行的能力或视力',
    loss_limb: '丧失肢体或其功能',
    loss_congenial_emp: '失去适宜的工作',
    loss_pride_pleasure: '失去对自己的工作的自豪感和乐趣',
    loss_marriage: '失去婚姻前景',
    loss_breakdown_family: '家庭破裂',
    loss_sexual_function: '丧失性功能',
    loss_sexual_interest: '对性失去兴趣',
    loss_give_birth: '丧失生育能力',
    loss_natural_childbirth: '丧失自然分娩的能力',
    loss_mental_ability: '丧失精神或心理能力',
    loss_personality: '人格改变',
    loss_life_expectation: '预计寿命损失',
    loss_confidence_public: '对在公众场合外出失去自信心',
    loss_grandchildren: '丧失照顾儿孙的乐趣',
    loss_children: '丧失亲子玩乐的乐趣',
    loss_pleasure_parenthood: '被剥夺父母养育子女的乐趣',
    loss_social_activities: '失去参与社交活动、运动及兴趣的能力',
    loss_rewarding_occupation: '丧失从事有价值和愉快的职业的能力',
    loss_family_social_pleasure: '丧失天伦之乐及社交情谊',
    comparable_cases: {text:'同类案例'},
    more_serious: {text:'比本案伤势较重'},
    similar: {text:'接近本案的伤势'},
    level_unspecified: {text: '未有标示伤势'},
    less_serious: {text:'比本案伤势较轻'},
    psla_amount: {text:'损害赔偿金额', unit:'$ {n}'},
    treatment_type_received:{text: '接受的治疗'},
  },
  dt:{
    title: '贩毒案件',
    selecthint: '选择被告人以显示相关信息',
    f_charge_single: '控罪',
    f_charge: '第{0}项控罪',
    f_defendant_single: '被告人',
    f_defendant: '第{0}被告人',
    charge_name: {text: '控罪'},
    drugs: {text: '毒品种类及重量', default_unit: '{n} 克'},
    cocaine: {text: '可卡因', unit:  '{n} 克'},
    heroin: {text: '海洛因', unit: '{n} 克'},
    methamphetamine: {text: '冰毒', unit: '{n} 克'},
    ketamine: {text: '氯胺酮', unit: '{n} 克'},
    nimetazepam: {text: '硝甲西泮', unit: '{n} 克'},
    ecstasy: {text: '摇头丸', unit: '{n} 克'},
    cannabisresin: {text: '大麻精', unit: '{n} 克'},
    herbalcannabis: {text: '大麻草', unit: '{n} 克'},
    aggravate: {text: '加刑因素', unit: ' | +{n} 个月 | +{n} 个月'},
    refugee: {text: '难民申请人', unit: ' | +{n} 个月 | +{n} 个月'},
    bail: {text: '保释期间犯罪', unit: ' | +{n} 个月 | +{n} 个月'},
    street: {text: '于街上贩运毒品', unit: ' | +{n} 个月 | +{n} 个月'},
    persistent: {text: '惯犯', unit: ' | +{n} 个月 | +{n} 个月'},
    international: {text: '跨境贩毒', unit: ' | +{n} 个月 | +{n} 个月'},
    aggravating_others: {text: '其他加刑因素', unit: ' | +{n} 个月 | +{n} 个月'},
    //totalagg: {text: 'Total sentence added for aggravating factors', unit: '+{n} 个月'},
    sentence: {text: '刑期', unit: '{n} 个月'},
    training_centre: '敎导所令',
    detention_centre: '劳敎中心令',
    addiction_treatment_centre: '戒毒所令',
    probation_order: '感化令',
    rehabiltation_centre_order: '更生中心令',
    guilty_plea: {text: '认罪'},
    guilty_plea_stage: {text: '阶段'},
    guilty_plea_sentence_str: {text: '扣减', unit: '"{n}"'},  // string
    guilty_plea_sentence_month: {text: '扣减', unit: '扣减 {n} 个月'},  // months
    guilty_plea_sentence_percent: {text: '扣减', unit: '{n}%'},  // percentage
    plea_not_guilty: '不认罪',
    high_unknown: '没有提及',
    high_committal: '裁判法院进行的交付审判程序前',
    high_before_fix_trial_date: '交付审判程序后至排期审讯前',
    high_before_trial: '排期审讯后至首日审讯前',
    high_first_day: '审讯首日',
    high_during_trial: '審訊期間',
    district_unknown: '没有提及',
    district_plea_day: '直至移交区域法院答辩日为止',
    district_before_trial: '排期审讯后至首日审讯期间',
    district_first_day: '审讯首日',
    district_during_trial: '审讯期间',
    mitigate:  {text: '减刑因素'},
    remorse: {text: '被告人有悔意', unit: ' | −{n} 个月 | −{n} 个月'}, 
    self_consume: {text: '自用相当比例毒品', unit: ' | −{n} 个月 | −{n} 个月'},
    controlled_delivery: {text: '协助有关当局', unit: ' | −{n} 个月 | −{n} 个月'},
    testimony: {text: '协助有关当局', unit: ' | −{n} 个月 | −{n} 个月'},
    good_character: {text: '正面良好品格', unit: ' | −{n} 个月 | −{n} 个月'},
    mitigating_others: {text: '其他减刑因素', unit: ' | −{n} 个月 | −{n} 个月'},
    background: {text: '被告人背景'},
    foreigner: '外国人',
    commission_age: {text: '犯案时岁数', unit: '{n}'},
    sentencing_age: {text: '审讯时岁数', unit: '{n}'},
    extreme_youth: '极度年青',
    previous_criminal_records: '有过往刑事纪录',
    clear_record: '没有定罪纪录',
    starting_point: {text: '量刑起点', unit: '{n} 个月'},
    single_charge_penalty: '刑期',
    penalty: {text: '刑罚'},
    unspecified: '未指定',
  }
}